import React from "react";
import styles from "./styles.module.css";
import { UtilitiesDisbatch } from "../../../contexts/utilities";
export default function OpenUtilities() {
  const utilityDisbatch = React.useContext(UtilitiesDisbatch);
  const onClick = () => utilityDisbatch({ type: "setOpen", value: true });
  return (
    <button className={styles.actionButton} onClick={onClick}>
      Utilites
    </button>
  );
}
